import { DateTime } from 'luxon';
import {
  clampAnchorToEventListBounds,
  getEventListBounds,
} from '@/features/events/lib/eventListWindow.lib';
import type { DateTimeRange } from '@/features/events/lib/range.lib';
import { getDisplayTimezone } from '@/features/experiences/lib/experience';
import type { PageExperience } from '@/features/experiences/types';
import type { PrintableTemplate } from '../../types';

export const getRangeBounds = (
  experience: PageExperience
): { start: DateTime; end: DateTime } =>
  getEventListBounds(experience, getDisplayTimezone(experience));

const clampAnchor = (anchor: DateTime, experience: PageExperience) =>
  clampAnchorToEventListBounds(
    anchor,
    experience,
    getDisplayTimezone(experience)
  );

export const getRangeForAnchor = (
  anchor: DateTime,
  experience?: PageExperience
): DateTimeRange => {
  const clamped = experience ? clampAnchor(anchor, experience) : anchor;
  return {
    startDate: clamped.startOf('month'),
    endDate: clamped.endOf('month'),
  };
};

export const getDefaultRange: NonNullable<
  PrintableTemplate<unknown>['getDefaultRange']
> = (experience) => {
  const anchor = clampAnchor(
    DateTime.local({ zone: getDisplayTimezone(experience) }),
    experience
  );
  return getRangeForAnchor(anchor);
};
